import React, { useState, useEffect } from "react";
import { observer } from "mobx-react";
import { useParams } from "react-router-dom";
import moment from "moment-timezone";

import Card from "../Components/Theme/Card";
import {
  getSession,
  getCourse,
  getUser,
  getExam,
  getUserTransactions,
  getInstall,
} from "../lib/apiClient";
import PermittedItems from "../Components/Session/PermittedItems";
import ModalityOptions from "../Components/Session/ModalityOptions";
import ProctorTypes from "../Components/Session/ProctorTypes";
import CopyValue from "../Components/Theme/Utilities/CopyValue";
import ShortSid from "../Components/Theme/Utilities/ShortenSid";
import DisplayTime from "../Components/Theme/Utilities/DisplayTime";


const Session = observer((props) => {
  const { sessionSid } = useParams();
  
  const [session, setSession] = useState(null);
  const [currentSessionSid, setCurrentSessionSid] = useState(null);
  const [, setCourse] = useState(null);
  const [exam, setExam] = useState(null);
  const [user, setUser] = useState(null);
  //const [instructor, setInstructor] = useState(null);
  const [install, setInstall] = useState(null);
  const [, setTransactions] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [timezone, setTimezone] = useState("America/Chicago");

  const fullHeightStyle = {
    height: "100vh",
  };

  useEffect(() => {
    const fetchSession = async (sessionSid) => {
      const sessionResponse = await getSession(sessionSid);

      if (sessionResponse.successful) {
        setSession(sessionResponse.data);
        setCurrentSessionSid(sessionSid);
      } else {
        console.log("Error");
        setError(true);
        setLoading(false);
      }
    };

    setLoading(true);
    fetchSession(sessionSid);

    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      const courseResponse = await getCourse(
        session.installSid,
        session.courseSid
      );
      setCourse(courseResponse.data);

      const examResponse = await getExam(
        session.installSid,
        session.courseSid,
        session.examSid
      );
      setExam(examResponse.data);

      const userResponse = await getUser(session.installSid, session.userSid);
      setUser(userResponse.data);

      if(props.store.SessionStore?.timezones[userResponse.data?.timeZoneSid]){
        setTimezone(props.store.SessionStore?.timezones[userResponse.data.timeZoneSid].name);
      }      

      const transactionResponse = await getUserTransactions(
        session.installSid,
        session.userSid,
        session.examSid
      );
      setTransactions(transactionResponse.data);

      const installResponse = await getInstall(session.installSid);
      setInstall(installResponse.data);
      setLoading(false);
      
    };

    if (currentSessionSid && currentSessionSid.length) {
      // load the session info...
      fetchData();
    }

    // eslint-disable-next-line
  }, [currentSessionSid]);

  return (
    <>
      {loading === false && error === false ? (
        <>
          <div className="row">
            <div className="col-12">
              <div className="card mb-4">
                <div className="user-profile-header d-flex flex-column flex-sm-row text-sm-start text-center mb-4">
                  <div className="flex-shrink-0 mt-n2 mx-sm-0 mx-auto">
                    {/*
                <img
                  src="https://demos.pixinvent.com/vuexy-html-admin-template/assets/img/avatars/1.png"
                  alt="user image"
                  className="d-block h-auto ms-0 ms-sm-4 rounded user-profile-img"
                />
                 */}
                  </div>
                  <div className="flex-grow-1 mt-3 mt-sm-5">
                    <div className="d-flex align-items-md-end align-items-sm-start align-items-center justify-content-md-between justify-content-start mx-4 flex-md-row flex-column gap-4">
                      <div className="user-profile-info">
                        <h4 className="text-primary">
                          {user?.firstName} {user?.lastName}
                        </h4>
                        <h5>{install?.name}</h5>
                        <ul className="list-inline mb-0 d-flex align-items-center flex-wrap justify-content-sm-start justify-content-center gap-2">
                          <li className="list-inline-item">
                            <i className="ti ti-mail"></i> {user?.email}{" "}
                            <CopyValue text={user?.email} />
                          </li>
                          <li className="list-inline-item">
                            <i className="ti ti-calendar"></i> {timezone} (
                            {moment.tz(timezone).format("z")}) (
                            {moment.tz(timezone).format("Z")} GMT)
                          </li>
                          {user?.mobilePhone ? (
                            <li className="list-inline-item">
                              <i className="ti ti-phone"></i> {user?.mobilePhone}
                            </li>
                          ) : (
                            <></>
                          )}
                        </ul>
                      </div>
                      {/* 
                  <a
                    href="javascript:void(0)"
                    className="btn btn-primary waves-effect waves-light"
                  >
                    <i className="ti ti-user-check me-1"></i>Connected
                  </a>
                  */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        
          {/* 
          <div className="row">
            <div className="col-md-12">
              <div className="nav-align-top">
                <ul className="nav nav-pills flex-column flex-sm-row mb-4 gap-2 gap-lg-0">
                  <li className="nav-item">
                    <a className="nav-link active" href="javascript:void(0);">
                      <i className="ti-sm ti ti-user-check me-1_5"></i> Overview
                    </a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" href="pages-profile-teams.html">
                      <i className="ti-sm ti ti-users me-1_5"></i> Identity
                    </a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" href="pages-profile-projects.html">
                      <i className="ti-sm ti ti-layout-grid me-1_5"></i> Logs
                    </a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" href="pages-profile-connections.html">
                      <i className="ti-sm ti ti-link me-1_5"></i> Related
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          */}

          <div className="row">
            <div className="col-xl-4 col-lg-5 col-md-5">
              <Card title="Session">
                <ul className="list-unstyled">
                  <li className="d-flex align-items-center mb-2">
                    <span className="fw-bold mx-2">Id:</span>
                    <span>
                      <ShortSid sid={session?.sid} />
                    </span>
                  </li>
                  <li className="d-flex align-items-center mb-2">
                    <span className="fw-bold mx-2">Status:</span>
                    <span>{session?.status}</span>
                  </li>
                  <li className="d-flex align-items-center mb-2">
                    <span className="fw-bold mx-2">Modality:</span>
                    <span>
                      {props.store.SessionStore?.proctorSubTypes[
                        session?.proctorTypeSid
                      ] ? (
                        <>
                          {
                            props.store.SessionStore?.proctorSubTypes[
                              session?.proctorTypeSid
                            ]?.title
                          }
                        </>
                      ) : (
                        <>{session?.schedulingModule}</>
                      )}
                    </span>
                  </li>
                </ul>
              </Card>

              <Card title="Dates">
                <ul className="list-unstyled mb-4">
                  <li className="d-flex align-items-center mb-2">
                    <span className="fw-bold mx-2">Appointment:</span>
                    <span>
                      <DisplayTime
                        date={session?.appointmentDate}
                        tz={timezone}
                      />
                    </span>
                  </li>
                  <li className="d-flex align-items-center mb-2">
                    <span className="fw-bold mx-2">Scheduled:</span>
                    <span>
                      <DisplayTime
                        date={session?.dateScheduled}
                        tz={timezone}
                      />
                    </span>
                  </li>
                </ul>
              </Card>

              <Card title="Proctor Types">
                <ProctorTypes
                  proctorTypes={session?.examConfiguration?.proctorTypes}
                  SessionStore={props.store.SessionStore}
                />
              </Card>

              <Card title="Modality Options">
                {session?.examConfiguration?.modalityOptions ? (
                  <ModalityOptions
                    modalityOptions={
                      session?.examConfiguration?.modalityOptions[
                        session.proctorTypeSid
                      ]
                    }
                  />
                ) : (
                  <></>
                )}
              </Card>
            </div>
            <div className="col-xl-8 col-lg-7 col-md-7">
              <Card title="Exam">
                <ul className="list-unstyled">
                  <li className="d-flex align-items-center mb-2">
                    <span className="fw-bold mx-2">Id:</span>
                    <span>
                      <ShortSid sid={exam?.sid} />
                    </span>
                  </li>
                  <li className="d-flex align-items-center mb-2">
                    <span className="fw-bold mx-2">Status:</span>
                    <span>{exam?.status}</span>
                  </li>
                  <li className="d-flex align-items-center mb-2">
                    <span className="fw-bold mx-2">Title:</span>
                    <span>{exam?.title}</span>
                  </li>
                  <li className="d-flex align-items-center mb-2">
                    <span className="fw-bold mx-2">Type:</span>
                    <span>{exam?.type}</span>
                  </li>
                  <li className="d-flex align-items-center mb-2">
                    <span className="fw-bold mx-2">URL:</span>
                    <span>{exam?.url}</span> <CopyValue text={exam?.url} />
                  </li>
                  <li className="d-flex align-items-center">
                    <span className="fw-bold mx-2">Required Approval:</span>
                    <span>{exam?.requireApproval ? <>Yes</> : <>No</>}</span>
                  </li>
                </ul>
              </Card>

              <Card title="Configuration">
                <ul className="list-unstyled">
                  <li className="d-flex align-items-center mb-2">
                    <span className="fw-bold mx-2">Is Accomodation:</span>
                    <span>
                      {session?.examConfiguration?.type === "primary" ? (
                        <>No</>
                      ) : (
                        <>Yes</>
                      )}
                    </span>
                  </li>
                  <li className="d-flex align-items-center mb-2">
                    <span className="fw-bold mx-2">Attempts:</span>
                    <span>
                      {session?.examConfiguration?.attemptsRemaining} of{" "}
                      {session?.examConfiguration?.attempts} remaining
                    </span>
                  </li>
                  <li className="d-flex align-items-center mb-2">
                    <span className="fw-bold mx-2">Duration:</span>
                    <span>{session?.examConfiguration?.duration} minutes</span>
                  </li>
                  <li className="d-flex align-items-center mb-2">
                    <span className="fw-bold mx-2">Exam Window:</span>
                    <span>
                      <DisplayTime
                        date={session?.examConfiguration?.examOpenDate}
                        tz={timezone}
                      />{" "}
                      -{" "}
                      <DisplayTime
                        date={session?.examConfiguration?.examCloseDate}
                        tz={timezone}
                      />
                    </span>
                  </li>
                  <li className="d-flex align-items-center mb-2">
                    <span className="fw-bold mx-2">Scheduling Window:</span>
                    <span>
                      <DisplayTime
                        date={session?.examConfiguration?.scheduleOpenDate}
                        tz={timezone}
                      />{" "}
                      -{" "}
                      <DisplayTime
                        date={session?.examConfiguration?.scheduleCloseDate}
                        tz={timezone}
                      />
                    </span>
                  </li>
                  {/* 
                  <li className="d-flex align-items-center mb-2">
                    <span className="fw-bold mx-2">Password:</span>
                    <span>{session?.examConfiguration?.password}</span>
                  </li>
                  */}
                </ul>
              </Card>

              <Card title="Permitted Items">
                <PermittedItems
                  examConfiguration={session?.examConfiguration}
                />
              </Card>

              <Card title="Student Notes">
                {session?.examConfiguration?.studentNotes.length ? (
                  <>{session?.examConfiguration?.studentNotes}</>
                ) : (
                  <>No student notes provided.</>
                )}
              </Card>

              <Card title="Proctor Notes">
                {session?.examConfiguration?.proctorNotes.length ? (
                  <>{session?.examConfiguration?.proctorNotes}</>
                ) : (
                  <>No proctor notes provided.</>
                )}
              </Card>
            </div>
          </div>
        </>
      ) : (<></>)}

      {loading ? (
        <div
        className="d-flex justify-content-center align-items-center"
        style={fullHeightStyle}
        >
          <div className="text-center">
            <div className="col-md p-6">
              <div
                className="spinner-border spinner-border-lg text-primary"
                role="status"
              >
                <span className="visually-hidden">Loading...</span>
              </div>
              <div className="fw-medium mb-4">Loading Session Data...</div>
            </div>
          </div>
        </div>
      ) : (<></>)}

      {error ? (
        <div
        className="d-flex justify-content-center align-items-center"
        style={fullHeightStyle}
        >
          <div className="text-center">
            <div className="col-md p-6">
              <div className="mb-2">
                <img src="../../theme/assets/img/illustrations/page-misc-error.png" alt="page-misc-not-authorized" width="170" className="img-fluid" />
              </div>
              <h4 className="mb-2 mx-2">Session not found</h4>
              <p className="mb-6 mx-2">Darn, the session with id <strong>{sessionSid}</strong> could not be located.</p>
            </div>
          </div>
        </div>
      ) : (<></>)}


    </>
  );
});

export default Session;
